import React, { createContext, useContext, useState, useCallback } from 'react';

interface DocumentPanelContextValue {
  showDocPanel: boolean;
  setShowDocPanel: (show: boolean) => void;
  openDocPanel: () => void;
  closeDocPanel: () => void;
}

const DocumentPanelContext = createContext<DocumentPanelContextValue>({
  showDocPanel: false,
  setShowDocPanel: () => {},
  openDocPanel: () => {},
  closeDocPanel: () => {},
});

export const useDocumentPanel = () => useContext(DocumentPanelContext);

export const DocumentPanelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showDocPanel, setShowDocPanel] = useState(false);

  const openDocPanel = useCallback(() => {
    setShowDocPanel(true);
    // Dispatch after state update via microtask
    Promise.resolve().then(() => {
      window.dispatchEvent(new CustomEvent('docpanel:open'));
    });
  }, []);

  const closeDocPanel = useCallback(() => {
    setShowDocPanel(false);
  }, []);

  return (
    <DocumentPanelContext.Provider value={{ showDocPanel, setShowDocPanel, openDocPanel, closeDocPanel }}>
      {children}
    </DocumentPanelContext.Provider>
  );
};
